import { useCallback } from 'react';
import { useLogAnalyticsEvent } from 'shared/src/hooks';

type LogClickSortParams = {
  sortKey: string;
};

export const useLogClickSort = () => {
  const logAnalyticsEvent = useLogAnalyticsEvent();

  return useCallback(
    ({ sortKey }: LogClickSortParams) => {
      logAnalyticsEvent({
        name: 'CLICK_SORT',
        analytics: {
          SORT_TYPE: sortKey,
        },
      });
    },
    [logAnalyticsEvent],
  );
};
